import { DelayDeviceBox, ExciterDeviceBox } from "@opendaw/studio-boxes";
import { Unhandled, UUID } from "@opendaw/lib-std";
export class AudioEffectFactory {
    static write(boxGraph, audioUnitBox, effect) {
        switch (effect.key) {
            case "delay": {
                const e = effect;
                return DelayDeviceBox.create(boxGraph, UUID.generate(), box => {
                    box.delayMusical.setValue(e.delay);
                    box.feedback.setValue(e.feedback);
                    box.cross.setValue(e.cross);
                    box.filter.setValue(e.filter);
                    box.dry.setValue(e.dry);
                    box.wet.setValue(e.wet);
                    box.enabled.setValue(e.enabled);
                    box.label.setValue(e.label); // TODO uniquify?
                    box.host.refer(audioUnitBox.audioEffects);
                });
            }
            case "exciter": {
                const e = effect;
                return ExciterDeviceBox.create(boxGraph, UUID.generate(), box => {
                    box.frequency.setValue(e.frequency);
                    box.drive.setValue(e.drive);
                    box.blend.setValue(e.blend);
                    box.mix.setValue(e.mix);
                    box.enabled.setValue(e.enabled);
                    box.label.setValue(e.label);
                    box.host.refer(audioUnitBox.audioEffects);
                });
            }
            default:
                return Unhandled(effect.key);
        }
    }
}
